export const LEGAL_TEMPLATE_PURCHASE_COMPLETE = 'LEGAL_TEMPLATE_PURCHASE_COMPLETE';

export interface PurchaseCompleteMessage {
  type: typeof LEGAL_TEMPLATE_PURCHASE_COMPLETE;
  correlationId: string;
  organizationId: string;
  packageId: string | null;
  subscriptionId: string | null;
  purchasedAt: string;
}

export const isAllowedSignatureOrigin = (origin: string): boolean => {
  const allowed = (import.meta.env.VITE_SIGNATURE_ORIGIN || '').replace(/\/$/, '');
  return Boolean(allowed) && origin.replace(/\/$/, '') === allowed;
};

const isNullableString = (value: unknown): value is string | null =>
  value === null || typeof value === 'string';

export const parsePurchaseCompleteMessage = (data: unknown): PurchaseCompleteMessage | null => {
  if (!data || typeof data !== 'object') return null;
  const payload = data as Record<string, unknown>;
  if (payload.type !== LEGAL_TEMPLATE_PURCHASE_COMPLETE) return null;
  if (typeof payload.correlationId !== 'string' || payload.correlationId.trim() === '') return null;
  if (typeof payload.organizationId !== 'string') return null;
  if (!isNullableString(payload.packageId)) return null;
  if (!isNullableString(payload.subscriptionId)) return null;
  if (typeof payload.purchasedAt !== 'string' || payload.purchasedAt.trim() === '') return null;

  return {
    type: LEGAL_TEMPLATE_PURCHASE_COMPLETE,
    correlationId: payload.correlationId,
    organizationId: payload.organizationId,
    packageId: payload.packageId,
    subscriptionId: payload.subscriptionId,
    purchasedAt: payload.purchasedAt,
  };
};
